/**
 * products.js — Sample product data for Jesse B Tattoos
 */

export const products = [
  {
    id: 'gift-card-50',
    name: 'Gift Card — $50',
    description:
      'The perfect gift for someone ready to get inked. Redeemable on any tattoo session or product.',
    price: '$50.00',
    image: '/images/gift_card_50.png',
    purchaseUrl: 'https://square.link/u/XItGMbbh',
    category: 'Gift Cards',
    badge: 'Gift',
  },
  {
    id: 'gift-card-100',
    name: 'Gift Card — $100',
    description:
      'Give the gift of custom art. $100 gift card redeemable across all sessions and store products.',
    price: '$100.00',
    image: '/images/gift_card_100.png',
    purchaseUrl: 'https://square.link/u/u8fXWi93',
    category: 'Gift Cards',
    badge: 'Gift',
  },
  {
    id: 'gift-card-500',
    name: 'Gift Card — $500',
    description:
      'For serious ink. $500 gift card covering larger sessions or multi-session work.',
    price: '$500.00',
    image: '/images/gift_card_500.png',
    purchaseUrl: 'https://square.link/u/q9eqm6sb',
    category: 'Gift Cards',
    badge: 'Popular',
  },
  {
    id: 'aftercare-kit',
    name: 'Proper Tattoo Aftercare Kit',
    description:
      'Everything you need to keep your fresh ink looking sharp. Includes balm, wrap, and care card.',
    price: '$55.00',
    image: '/images/Properkit.webp',
    purchaseUrl: 'https://square.link/u/8XeFMjA5',
    category: 'Aftercare',
    badge: 'Popular',
  },
  {
    id: 'healing-balm',
    name: 'Proper Healing Balm',
    description:
      'Handpicked ingredients. Zero nasties. Our signature balm keeps your tattoo moisturised and vibrant.',
    price: '$25.00',
    image: '/images/Proper.webp',
    purchaseUrl: 'https://square.link/u/0PK5pDV1',
    category: 'Aftercare',
    badge: null,
  },
  
 
]